import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import img13 from "../../../images/service/NftMarketing1.png"; 
import img14 from "../../../images/service/NftMarketing2.png"; 

import m05 from "../../../images/icon/m_05.svg";

import growth from "../../../images/icon/service-icon03.svg"
import setup from "../../../images/icon/feaicons/fea-small-icon04.svg"
import influence from "../../../images/icon/feaicons/fea-small-icon06.svg"
import discord from "../../../images/icon/discord.svg";
import Seo from "../../../images/icon/SeoMarketing.svg";
import Social from "../../../images/icon/Social.svg"

//import diamondIcon from "../../../images/icon/diamond-icon01.gif";
//import diamondIcon from "../../../images/icon/diamond-icon02.gif";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

// ---------------------------
// Data
// ---------------------------

const serviceCards = [
  {
    title: "NFT Marketing Strategy",
    content:
      "We create custom NFT marketing strategies aligned with your brand vision, target audience, and project roadmap.",
    icon: growth, // 📈 strategy & growth
  },
  {
    title: "Influencer & Community Growth",
    content:
      "Partner with top-tier NFT influencers, KOLs, and community leaders to boost project visibility and trust.",
    icon: influence, // 🤝 influencers
  },
  {
    title: "Social Media Management",
    content:
      "We craft compelling storytelling content across Twitter, Discord, Telegram, and Instagram.",
    icon: Social, // 💬 social media
  },
  {
    title: "Paid Ads & Conversion Funnels",
    content:
      "Results-driven ad campaigns tailored for NFT launches, mints, and marketplaces.",
    icon: setup, // 💰 paid / funnel
  },
  {
    title: "SEO & Content Marketing",
    content:
      "Rank your NFT project on Google through optimized long-form content & press releases.",
    icon: Seo, // 🔍 SEO
  },
  {
    title: "Discord Setup & Automation",
    content:
      "We build structured, automated, and engagement-rich Discord communities.",
    icon: discord, // 🤖 Discord
  },
];


const benefits = [
  "Boost project credibility and trust instantly.",
  "Increase whitelist conversions through strategic marketing.",
  "Grow a highly-engaged NFT community organically.",
  "Improve launch visibility across all NFT platforms.",
  "Create long-term brand recall for your collection.",
  "Maximize mint-out chances with proven marketing playbooks.",
];

const faqs = [
  {
    q: "How long does NFT marketing take?",
    a: "Most NFT marketing campaigns take 30–90 days depending on goals such as mint-out, community growth, or brand visibility.",
  },
  {
    q: "Do you promote NFT mints?",
    a: "Yes, we run full-stack marketing campaigns including influencer outreach, ads, Discord growth, PR, and hype cycles.",
  },
  {
    q: "Can you guarantee a mint-out?",
    a: "No ethical agency guarantees mint-outs, but our campaigns maximize conversions with proven growth frameworks.",
  },
  {
    q: "Do you handle Web3 partnerships?",
    a: "Yes, we help with collabs, KOL partnerships, AMAs, Twitter spaces, and ecosystem-level networking.",
  },
];

// ---------------------------
// PAGE COMPONENT
// ---------------------------

export default function NFTMarketing() {
  const [openFAQ, setOpenFAQ] = React.useState<number | null>(null);

  return (
    <Fragment>
      <Header />

      <PageTitle pageTitle="NFT Marketing Services" pagesub="Scale your NFT project with proven Web3 marketing frameworks." />


      {/* ================= HERO SECTION ================= */}
      <section className="xb-hero-section pt-120 pb-60">
        <div className="container">
          <div className="row align-items-center">
            
            {/* LEFT CONTENT */}
            <div className="col-lg-6 col-md-12 wow fadeInLeft" data-wow-delay="100ms">

              <h1 className="xb-hero-title mt-20">
                Boost Your NFT Project with{" "}
                <span className="gradient-text">Strategic NFT Marketing</span>
              </h1>

              <p className="xb-hero-subtext mt-20">
                We help NFT creators, brands, and marketplaces grow their reach,
                build strong communities, and execute high-impact campaigns that
                drive real conversions and long-term scalability.
              </p>

              <div className="mt-30">
                <Link to="/contact" className="xb-btn">
                  Book Consultation
                </Link>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 col-md-12 text-center wow fadeInRight" data-wow-delay="200ms">
              <img src={img13} alt="NFT Marketing Banner" className="xb-hero-img" />
            </div>

          </div>
        </div>
      </section>

      {/* ================= SHORT THEORY ================= */}
      <section className="pt-30 pb-30">
        <div className="container">
          <p className="xb-long-text wow fadeInUp text-center" data-wow-delay="100ms">
            NFT marketing is more than promotions — it is a strategic blend of
            branding, storytelling, influencer engagement, community building,
            and targeted visibility.
          </p>
        </div>
      </section>

      {/* ================= SERVICE CARDS ================= */}
<section className="pt-80 pb-80">
  <div className="container">
    <h2 className="xb-section-title text-center wow fadeInUp">
      Our NFT Marketing Services
    </h2>

    <div className="row mt-40">
      {serviceCards.map((card, i) => (
        <div
          className="col-lg-4 col-md-6 mb-30 wow fadeInUp"
          data-wow-delay={`${i * 80}ms`}
          key={i}
        >
          <div
            className="xb-service-card-v2"
            style={{
              minHeight: "320px",          // 🔥 Equal card height
              borderRadius: "16px",
              padding: "35px 28px",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              backdropFilter: "blur(10px)",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              transition: "0.3s",
            }}
          >

            {/* ICON */}
            <div
              className="icon-wrap"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "14px",
                background: "rgba(255,255,255,0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "18px",
              }}
            >
              <img src={card.icon} alt={card.title} style={{ width: "38px" }} />

            </div>

            {/* TITLE */}
            <h4
              style={{
                fontSize: "20px",
                fontWeight: 600,
                color: "#fff",
                marginBottom: "12px",
                minHeight: "56px", // keeps titles aligned
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              {card.title}
            </h4>

            {/* CONTENT */}
            <p
              style={{
                fontSize: "15px",
                color: "rgba(255,255,255,0.85)",
                lineHeight: "1.6",
              }}
            >
              {card.content}
            </p>

          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* ================= DEEP THEORY ================= */}
      <section className="pt-60 pb-60 bg-light-gradient">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 wow fadeInLeft">
              <h2 className="xb-section-title">Why NFT Marketing Matters</h2>
              <p className="xb-long-text mt-20">
                In a fast-paced Web3 world, visibility is everything. A powerful
                NFT marketing strategy helps your project break through market
                noise and maintain roadmap engagement.
              </p>
            </div>

            <div className="col-lg-6 text-center wow fadeInRight">
              <img src={img14} className="xb-deep-img" alt="" />
            </div>

          </div>
        </div>
      </section>

      {/* ================= BENEFITS ================= */}
<section className="pt-80 pb-80">
  <div className="container">
    <h2 className="xb-section-title text-center wow fadeInUp">
      Benefits of NFT Marketing
    </h2>

    {/* CENTERED LIST WRAPPER */}
    <div
      className="mt-50 d-flex justify-content-center"
      style={{ width: "100%" }}
    >
      <ol
        style={{
          maxWidth: "750px",
          width: "100%",
          margin: 0,
          padding: 0,
          listStylePosition: "inside",
          fontSize: "18px",
          color: "rgba(255,255,255,0.9)",
          lineHeight: "1.8",
        }}
      >
        {benefits.map((b, i) => (
          <li
            key={i}
            className="wow fadeInUp"
            data-wow-delay={`${i * 80}ms`}
            style={{
              marginBottom: "16px",
              padding: "18px 24px",
              borderRadius: "14px",
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              backdropFilter: "blur(10px)",
              transition: "0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px)";
              e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(0,0,0,0.25)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0px)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            {b}
          </li>
        ))}
      </ol>
    </div>
  </div>
</section>


      {/* ================= WHY CHOOSE US (NUMERIC STYLE) ================= */}
<section className="pt-80 pb-80 bg-dark-gradient">
  <div className="container">

    <h2 className="xb-section-title text-center text-white wow fadeInUp">
      Why Choose Us?
    </h2>

    <div className="row justify-content-center mt-50">

      {[
        "Proven Web3 Marketing Frameworks",
        "Dedicated NFT Growth Specialists",
        "End-to-End Campaign Execution",
      ].map((item, index) => (
        <div
          className="col-lg-4 col-md-6 mb-30 wow fadeInUp text-center"
          data-wow-delay={`${index * 100}ms`}
          key={index}
        >
          <div
            className="xb-numeric-card"
            style={{
              padding: "35px 30px",
              borderRadius: "16px",
              background: "rgba(255,255,255,0.06)",
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255,255,255,0.08)",
              transition: "0.3s",
            }}
          >
            {/* NUMBER CIRCLE */}
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                margin: "0 auto 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                fontWeight: 700,
                color: "#fff",
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.15), rgba(255,255,255,0.05))",
                border: "1px solid rgba(255,255,255,0.25)",
              }}
            >
              {index + 1}
            </div>

            {/* TEXT */}
            <h4 style={{ color: "#fff", fontWeight: 600 }}>{item}</h4>
          </div>
        </div>
      ))}

    </div>
  </div>
</section>

      {/* ================= FAQ ================= */}
<section className="pt-80 pb-80">
  <div className="container">
    <h2 className="xb-section-title text-center wow fadeInUp">
      Frequently Asked Questions
    </h2>

    {/* CENTER THE FAQ CONTENT */}
    <div 
      className="mt-40 d-flex justify-content-center"
      style={{ width: "100%" }}
    >
      <div style={{ width: "100%", maxWidth: "750px" }}>
        
        {faqs.map((f, i) => {
          const isOpen = openFAQ === i;

          return (
            <div
              key={i}
              className="wow fadeInUp xb-faq-wrapper"
              data-wow-delay={`${i * 80}ms`}
              style={{ marginBottom: "18px" }}
            >
              {/* ----- FAQ CARD ----- */}
              <div
                onClick={() => setOpenFAQ(isOpen ? null : i)}
                style={{
                  padding: "24px 28px",
                  borderRadius: "14px",
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  backdropFilter: "blur(10px)",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                {/* QUESTION ROW */}
                <div className="d-flex justify-content-between align-items-center">
                  <h4
                    style={{
                      margin: 0,
                      fontSize: 18,
                      fontWeight: 600,
                      color: "#fff",
                    }}
                  >
                    {f.q}
                  </h4>

                  <span
                    style={{
                      fontSize: 28,
                      color: "#fff",
                      transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                      transition: "0.25s",
                      fontWeight: 300,
                    }}
                  >
                    +
                  </span>
                </div>

                {/* ANSWER SECTION */}
                <div
                  style={{
                    maxHeight: isOpen ? "200px" : "0px",
                    overflow: "hidden",
                    transition: "max-height 0.35s ease",
                  }}
                >
                  <p
                    style={{
                      opacity: isOpen ? 1 : 0,
                      marginTop: isOpen ? 12 : 0,
                      transition: "opacity 0.25s ease",
                      color: "rgba(255,255,255,0.85)",
                      lineHeight: "1.6",
                    }}
                  >
                    {f.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}

      </div>
    </div>
  </div>
</section>



      {/* ================= FINAL CENTERED CTA ================= */}
<section className="pt-80 pb-80">
  <div className="container d-flex justify-content-center">
    
    <div 
      className="cta-wrapper wow fadeInUp"
      data-wow-delay="100ms"
      style={{
        maxWidth: "850px",
        width: "100%",
        textAlign: "center",
        position: "relative",
      }}
    >
      {/* CTA BOX */}
      <div
        className="service_link"
        style={{
          padding: "40px",
          borderRadius: "18px",
          background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div className="xb-item--inner">

          {/* ICON + TITLE */}
          <div className="xb-item--holder ul_li d-flex justify-content-center align-items-center">
            <span className="xb-item--icon" style={{ marginRight: "15px" }}>
              <img src={m05} alt="icon" style={{ width: 55 }} />
            </span>

            <h3 className="xb-item--title" style={{ margin: 0 }}>
              <Link to="/contact">
                Need expert blockchain services?
              </Link>
            </h3>
          </div>

          {/* SUBTEXT */}
          <p className="xb-item--text mt-20">
            We provide full-stack blockchain solutions.
          </p>
        </div>

        {/* CTA BUTTON WITH BOTH SVG ARROWS */}
        <Link 
          to="/contact" 
          className="xb-item--btn mt-30 d-inline-flex align-items-center justify-content-center"
          style={{
            padding: "12px 24px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, #6A5CFF, #3CE4B0)",
            color: "#fff",
            fontSize: "16px",
            fontWeight: 600,
            gap: "10px",
          }}
        >
          
          {/* First SVG */}
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="6.29297"
              y="21.4106"
              width="22.36"
              height="2.83936"
              transform="rotate(-40.2798 6.29297 21.4106)"
              fill="white"
            />
            <rect
              x="9.44922"
              y="7.56982"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 9.44922 7.56982)"
              fill="white"
            />
            <rect
              x="13.4492"
              y="7.89941"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 13.4492 7.89941)"
              fill="white"
            />
            <rect
              x="17.4492"
              y="8.23047"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 17.4492 8.23047)"
              fill="white"
            />
            <rect
              x="21.1211"
              y="12.562"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 21.1211 12.562)"
              fill="white"
            />
            <rect
              x="20.7969"
              y="16.5645"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 20.7969 16.5645)"
              fill="white"
            />
            <rect
              x="20.4648"
              y="20.5664"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 20.4648 20.5664)"
              fill="white"
            />
          </svg>

          {/* Second SVG */}
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="6.29297"
              y="21.4106"
              width="22.36"
              height="2.83936"
              transform="rotate(-40.2798 6.29297 21.4106)"
              fill="white"
            />
            <rect
              x="9.44922"
              y="7.56982"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 9.44922 7.56982)"
              fill="white"
            />
            <rect
              x="13.4492"
              y="7.89941"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 13.4492 7.89941)"
              fill="white"
            />
            <rect
              x="17.4492"
              y="8.23047"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 17.4492 8.23047)"
              fill="white"
            />
            <rect
              x="21.1211"
              y="12.562"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 21.1211 12.562)"
              fill="white"
            />
            <rect
              x="20.7969"
              y="16.5645"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 20.7969 16.5645)"
              fill="white"
            />
            <rect
              x="20.4648"
              y="20.5664"
              width="2.83936"
              height="2.83936"
              transform="rotate(-40.2798 20.4648 20.5664)"
              fill="white"
            />
          </svg>
        </Link>

      </div>
    </div>
  </div>
</section>


      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
